import { debounce } from '../../util/helpers';
import { setElementInert } from '../../util/a11y/handle-inert';
import strings from '../../lang/strings.json';

export default {
  init() {
    if (!document.querySelectorAll('.ms-salt-calc').length) { return; }

    this.currentLang = document.querySelector('html').lang;
    this.startCalculator();
  },
  animateButton(button, payload) {
    // simulate the loading
    // this is just for aesthetics since we have already fetched every product.
    button.classList.add('animating');

    setTimeout(() => {
      button.classList.remove('animating');
      this.renderResults(payload);
    }, 1000);
  },
  renderResults(payload) {
    const { amountIndex, type, convertTo, amountConverted } = payload;
    const staticMeasurements = [
      '1/4 TSP',
      '1 TSP',
      '1 TBSP',
      '1/4 Cup',
      '1/2 Cup',
      '3/4 Cup',
      '1 Cup',
      '2 Cups',
    ];

    const container = document.querySelector('.ms-salt-calc__results');
    const originHeader = container.querySelector('.ms-salt-calc__header .origin');
    const originAmount = originHeader.querySelector('.origin-amount');
    const originName = originHeader.querySelector('.origin-name');
    const convertHeader = container.querySelector('.ms-salt-calc__header .convert-to');
    const convertAmount = convertHeader.querySelector('.convert-amount');
    const convertName = convertHeader.querySelector('.convert-name');

    const products = container.querySelectorAll('.ms-salt-calc__product');
    const prodTable = container.querySelector('.ms-salt-calc__details');
    const ariaLiveAlert = document.querySelector('.ms-salt-calc__sr-alert');

    // toggle animation
    container.classList.add('ms-salt-calc__results--expanded');

    ariaLiveAlert.innerHTML = strings[this.currentLang].displayingConversionResults;

    setTimeout(() => {
      ariaLiveAlert.innerHTML = '';
    }, 3000);

    debounce(() => {
      this.resizePattern();
    }, 200);

    // set origin name and amount
    originAmount.innerHTML = '';
    originAmount.innerHTML = staticMeasurements[amountIndex];

    originName.innerHTML = '';
    originName.innerHTML = type.title;

    // set convert-to name and amount
    convertAmount.innerHTML = '';
    convertAmount.innerHTML = amountConverted;

    convertName.innerHTML = '';
    convertName.innerHTML = convertTo.title;

    // Products section
    products.forEach((product, index) => {
      // expecting only 2
      // index = 0 is type
      // index = 1 is convertTo
      const bgImage = product.querySelector('.macro img');
      const actualImage = product.querySelector('.actual img');
      const granulesImage = product.querySelector('.granules img');
      const prodName = product.querySelector('.ms-salt-calc__product-name');
      const prodCTA = product.querySelector('.ms-salt-calc__product-cta a');
      const prodCardCTA = product.querySelector('a');
      const description = product.querySelector('.ms-salt-calc__product-desc .desc-js');

      // assign to DOM
      // i know this is messy and long 😨
      bgImage.src = index === 0 ? type.background_image : convertTo.background_image;
      actualImage.src = index === 0 ? type.product_image : convertTo.product_image;
      prodName.innerHTML = index === 0 ? type.title : convertTo.title;
      prodCTA.href = index === 0 ? type.permalink : convertTo.permalink;
      prodCardCTA.href = index === 0 ? type.permalink : convertTo.permalink;
      prodCTA.setAttribute('aria-label', `${strings[this.currentLang].checkOut} ${index === 0 ? type.title : convertTo.title}`);
      description.innerHTML = index === 0 ? type.best_used_for : convertTo.best_used_for;

      // special condition for granules
      // this one too 😨
      if (index === 0) {
        if (type.bottom_image) {
          granulesImage.src = type.bottom_image;
        } else {
          granulesImage.removeAttribute('src');
          granulesImage.style.display = 'none';
        }
      } else {
        if (convertTo.bottom_image) {
          granulesImage.src = convertTo.bottom_image;
        } else {
          granulesImage.removeAttribute('src');
          granulesImage.style.display = 'none';
        }
      }
    });

    // Product Table Details
    const tableHeads = prodTable.querySelectorAll('thead th');
    const tableBody = prodTable.querySelector('tbody');

    tableHeads.forEach((head, index) => {
      head.innerHTML = index === 0 ? `<span>${type.title}</span>` : `<span>${convertTo.title}</span>`;
    });

    // complete table details
    // empty the current table first
    tableBody.innerHTML = '';

    // insert all details to table
    staticMeasurements.forEach((row, index) => {
      const newRow = `
        <tr>
          <td><span>${row}</span></td>
          <td><span>${convertTo.conversions[index]}</span></td>
        </tr>
      `;

      tableBody.innerHTML += newRow;
    });

    setTimeout(() => setElementInert(false, container));
  },
  resizePattern() {
    const container = document.querySelector('.ms-salt-calc');
    // calculate pattern's height
    const resultsContainer = container.querySelector('.ms-salt-calc__results');
    const pattern = container.querySelector('.ms-salt-calc__pattern');

    pattern.style.height = `${resultsContainer.getBoundingClientRect().height}px`;
  },
  startCalculator() {
    const container = document.querySelector('.ms-salt-calc');
    const tableToggle = container.querySelector('.ms-salt-calc__details-toggle button');
    const tableBlock = container.querySelector('.ms-salt-calc__details');

    // Dropdowns
    const amountOfSalt = container.querySelector('select#amount-of-salt');
    const typeOfSalt = container.querySelector('select#type-of-salt');
    const convertTo = container.querySelector('select#convert-to-salt');
    const convertCTA = container.querySelector('button.ms-salt-calc__convert-btn');

    // color change handler
    [amountOfSalt, typeOfSalt, convertTo].forEach(select => {
      select.addEventListener('change', ({ target }) => {
        target.classList.add('opened');
      })
    });

    // Collate salts into a list of options
    this.optionsList = {};

    Array.from(typeOfSalt.options).map(({ dataset }) => {
      const { details } = dataset;

      // exclude the null value options
      if (details) {
        const jsonDetails = JSON.parse(details);
        const { slug } = jsonDetails;

        this.optionsList[slug] = jsonDetails;
      }
    });

    // on load, fetch the first index's conversion options
    convertTo.innerHTML = '';
    if (this.optionsList[typeOfSalt.value]) {
      Object.entries(this.optionsList[typeOfSalt.value].entries).forEach(([key, option]) => {
        if (this.optionsList[key]) {
          convertTo.innerHTML += `<option value="${key}" data-post-id="${this.optionsList[key].id}">${option}</option>`;
        }
      })
    }

    // this is what we need to send to the service
    const payload = {
      amountIndex: 0,
      amountConverted: null,
      type: this.optionsList[typeOfSalt.value],
      convertTo: this.optionsList[convertTo.value],
    };

    // listen to changes in the amount of salt dropdown
    amountOfSalt.addEventListener('change', ({ target }) => {
      const { value } = target;

      payload.amountIndex = value;
    });

    // listen to type of salt changes
    typeOfSalt.addEventListener('change', ({ target }) => {
      const { value } = target;

      // empty the target dropdown and add the default option
      convertTo.innerHTML = '';


      // dynamically produce options
      // assign to payload
      payload.type = this.optionsList[value];
      payload.convertTo = null; // always reset this
      payload.amountConverted = null; // this too

      Object.entries(this.optionsList[value].entries).forEach(([key, option]) => {
        convertTo.innerHTML += `<option value="${key}" data-post-id="${this.optionsList[key].id}">${option}</option>`;
      });

      // Auto-assign the next value
      payload.convertTo = this.optionsList[convertTo.value];
    });

    // listen to convert to dropdown changes
    convertTo.addEventListener('change', ({ target }) => {
      const { value } = target;

      payload.convertTo = this.optionsList[value];
    })

    // listen to convert button clicks
    convertCTA.addEventListener('click', (e) => {
      e.preventDefault();

      // check payload if the essential items are null, return an error state
      if (!payload.convertTo || !payload.type) {
        // Need to confirm error state
        console.log('ERROR');
      } else {
        // do the math here

        // change all colors to black
        amountOfSalt.style.color = '#052D5D';
        typeOfSalt.style.color = '#052D5D';
        convertTo.style.color = '#052D5D';
        // look up the conversionTable for the salt we want to convert to + the index of the amount selected
        payload.amountConverted = payload.convertTo.conversions[payload.amountIndex]

        // pass all of this in another method to handle the ajax request
        this.animateButton(e.target, payload);
      }
    })

    debounce(() => {
      this.resizePattern();
    }, 200);

    tableToggle.addEventListener('click', ({ target }) => {
      const placeholderTag = tableBlock.firstElementChild;
      const resultsTableElement = tableBlock.querySelector('table');
      const toggleParent = tableToggle.parentElement;
      const theadForDesktop = resultsTableElement.querySelector('thead th');
      const allSpans = resultsTableElement.querySelectorAll('span');

      // here
      tableBlock.classList.toggle('ms-salt-calc__details--active');
      toggleParent.classList.toggle('ms-salt-calc__details-toggle--active');

      // for word transform
      if (toggleParent.classList.contains('ms-salt-calc__details-toggle--active')) {
        target.setAttribute('aria-expanded', true);
        target.querySelector('span.more-js').style.display = 'none';
        target.querySelector('span.less-js').style.display = 'inline-block';
        setElementInert(false, tableBlock);

        // fix for mobile iOS focus.
        if (/iPhone|iPod|iPad/.test(navigator.platform)) {
          allSpans.forEach(el => {
            el.setAttribute('tabindex', '-1');
          });
        }

        placeholderTag.setAttribute('tabindex', '-1');
        theadForDesktop.setAttribute('tabindex', '-1');
        resultsTableElement.setAttribute('tabindex', '-1');
        resultsTableElement.setAttribute('aria-label', strings[this.currentLang].conversionTable);

        setTimeout(() => {
          if (/iPhone|iPod|iPad/.test(navigator.platform)) {
            allSpans[0].focus();
          } else {
            placeholderTag.focus();
          }

        }, 1000);

      } else {
        target.setAttribute('aria-expanded', false);
        target.querySelector('span.less-js').style.display = 'none';
        target.querySelector('span.more-js').style.display = 'inline-block';
        setElementInert(true, tableBlock);

        allSpans.forEach(el => {
          el.removeAttribute('tabindex');
        });

        theadForDesktop.removeAttribute('tabindex');
        tableBlock.removeAttribute('role');
        tableBlock.removeAttribute('aria-label');
        resultsTableElement.removeAttribute('tabindex');
        resultsTableElement.removeAttribute('aria-label');
      }
    })
  },
}



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/modules/salt-conversion-calculator.js